/* globals modForm modUtils heap */
export function trackPageContextToGA4() {
	if (!window.dataLayer || modForm.opts.hasPageContextTrackedToGA4) {
		return false;
	}

	const queryParams = modUtils.getUrlParamsToObject();
	const quadLinkData = modForm.opts.quadLinkParams;
	const heapData = { heapIdentity: heap?.identity, heapUserId: heap?.userId };

	window.dataLayer.push({
		ga4PageData: JSON.stringify({
			...queryParams,
			...quadLinkData,
			...heapData
		}),
		event: 'PageContext'
	});

	modForm.opts.hasPageContextTrackedToGA4 = true;
}
